export class SupportingDocumentBean{
   
    fileName :string;
    fileSize :string;
    comments :string;
    fileType :string;
    isNCFinalized :string;
    privilegeArea :string;
    roleId :string;
    roleName :string;
    roleLevel :string;
    documentId :string;
    auditScopeId :string;
    entBy :string;
    entStamp :string;
    updBy :string;
    updStamp :string;
    uploadStage :string;
    companyId:string;
    buId:string;
    formattedFileSize:string;
    uploadStageValue:string;
    isFinalReportReleased:string;
    isScopeItemNC:string;
    enteredBy:string;
    showComments:boolean;
    totalSize:number;
    entStampDate:string;
    entStampTime:string;

}